/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable comma-dangle */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/pt';
import { TextField } from '@mui/material';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

function Harvests() {
  const [harvests, setHarvests] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [locale, setLocale] = React.useState('pt');
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const location = useLocation();
  const id = location?.state?.id;
  const pond = location?.state?.pond;

  const columns = [
    {
      title: 'Data de Despesca',
      field: 'date',
      type: 'date',
      hideFilterIcon: true,
      dateSetting: { locale: 'pt-BR' },
      editComponent: (props) => (
        <LocalizationProvider
          adapterLocale={deLocale}
          dateAdapter={DateFnsUtils}
        >
          <DatePicker
            format="dd/MM/yyyy"
            value={props.value}
            onChange={props.onChange}
            InputProps={{
              style: {
                fontSize: 13,
              },
            }}
            fullWidth
            // inputFormat="DD/MM/YYYY"
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      ),
    },
    {
      title: 'Produção Total (Kg)',
      field: 'production',
      editable: 'never',
      render: (rowData) => (
        <span>
          {`${new Intl.NumberFormat('pt-BR').format(
            rowData?.cycles?.reduce(
              (_total, _data) => _total + _data?.production,
              0
            )
          )} Kg`}
        </span>
      ),
      hideFilterIcon: true,
    },
    // {
    //   title: 'Status',
    //   field: 'status',
    //   type: 'string',
    //   editable: 'never',
    //   hideFilterIcon: true,
    //   render: (rowData) => (
    //     <Chip
    //       style={{
    //         backgroundColor:
    //           rowData.status === 'pendente' ? '#F44336' : '#0B8846',
    //         color: '#fff',
    //         fontWeight: 'bolder',
    //       }}
    //       label={rowData.status[0].toUpperCase() + rowData.status.substr(1)}
    //     />
    //   ),
    // },
    {
      title: 'Viveiros',
      field: 'pond',
      type: 'string',
      editable: 'never',
      render: (rowData) => (
        <>
          <span key={rowData.tableData.id}>
            {rowData.cycles
              .map((cycle) => cycle.cycle?.pond.description)
              .toString()}
          </span>
          <br />
        </>
      ),
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get(
          `/harvests/cycle-code/${selectedCycle.id}`,
          {
            params: id ? { cycle: id } : {},
          }
        );
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((harvest) => ({
            id: harvest.id,
            date: harvest.date,
            production: harvest?.cycles?.reduce(
              (_total, _data) => _total + _data?.production,
              0
            ),
            status: harvest.status[0].toUpperCase() + harvest.status.substr(1),
            pond: harvest.cycles
              .map((cycle) => cycle.cycle?.pond.description)
              .toString(),
            quantity: harvest?.cycles?.reduce(
              (sum, quantity) => sum + quantity?.quantity,
              0
            ),
          }));

          setExportData(organizedData);
          setHarvests(data);

          setOpenProgress(true);
        }
      } catch (err) {}
    }
    loadData();
  }, [selectedCycle]);

  function setData(newData) {
    const tempData = [];
    harvests.map((harvest) =>
      harvest.id === newData.id
        ? tempData.push(newData)
        : tempData.push(harvest)
    );
    setHarvests(tempData);
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  function CustomTitle() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            fontWeight: 500,
            fontSize: '20px',
            fontFamily: 'Roboto',
            marginInlineEnd: '10px',
          }}
        >
          Despescas
        </div>
        {pond ? (
          <div
            style={{
              padding: '5px',
              marginLeft: 'auto',
              border: '1px solid black',
              borderRadius: '10px',
              fontWeight: 600,
            }}
          >
            {pond.description}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <Table
      title="Despescas"
      titleCustomized={<CustomTitle />}
      route="/harvests/"
      routeAdd="/harvest/"
      columns={columns}
      data={harvests}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
    />
  );
}

export default Harvests;
